<div class="component-container" [class]="controlAction">
  <div class="game-part-line">
    <div class="game-part">{{ utilService.inningToShort(broadcast) }}</div>
    <div class="score-header">
      <ng-container *ngIf="isFinished()">
        <div *ngFor="let runs of game?.away?.scoreBoard; index as i">
          {{i+1}}
        </div>
      </ng-container>
      <div>R</div>
      <div *ngIf="broadcast?.gameId">H</div>
      <div *ngIf="broadcast?.gameId">E</div>
    </div>
  </div>
  <div class="teams-line">
    <div class="teams">
      <div class="team away" [style.background-color]="utilService.getTeamBgrByGuid(broadcast?.config?.awayConfig?.id, broadcast)">
        <div class="team-logo">
          <img *ngIf="!utilService.hideTeamLogos(broadcast)" src="{{ broadcast?.config?.awayConfig?.logoUrl }}" alt="{{ game?.away?.shortName }}">
          <span class="team-code" *ngIf="utilService.hideTeamLogos(broadcast)">{{ broadcast?.config?.awayConfig?.shortName }}</span>
        </div>
        <div class="team-name">{{ broadcast?.config?.awayConfig?.fullName }}</div>
        <ng-container *ngIf="isFinished()">
          <div class="runs-inning" *ngFor="let runs of game?.away?.scoreBoard; index as i">
            {{runs}}
          </div>
        </ng-container>
        <div class="runs">{{ game?.away.runs }}</div>
        <div class="hits" *ngIf="broadcast?.gameId">{{ game?.away?.hits }}</div>
        <div class="errors" *ngIf="broadcast?.gameId">{{ game?.away?.errors }}</div>
      </div>
      <div class="team home" [style.background-color]="utilService.getTeamBgrByGuid(broadcast?.config?.homeConfig?.id, broadcast)">
        <div class="team-logo">
          <img *ngIf="!utilService.hideTeamLogos(broadcast)" src="{{ broadcast?.config?.homeConfig?.logoUrl }}" alt="{{ game?.home?.shortName }}">
          <span class="team-code" *ngIf="utilService.hideTeamLogos(broadcast)">{{ broadcast?.config?.homeConfig?.shortName }}</span>
        </div>
        <div class="team-name">{{ broadcast?.config?.homeConfig?.fullName }}</div>
        <ng-container *ngIf="isFinished()">
          <div class="runs-inning" *ngFor="let runs of game?.away?.scoreBoard; index as i">
            {{game?.home.scoreBoard[i] != undefined ? game?.home?.scoreBoard[i] : '-'}}
          </div>
        </ng-container>
        <div class="runs">{{ game?.home?.runs }}</div>
        <div class="hits" *ngIf="broadcast?.gameId">{{ game?.home?.hits }}</div>
        <div class="errors" *ngIf="broadcast?.gameId">{{ game?.home?.errors }}</div>
      </div>
    </div>
    <div class="due-up" *ngIf="showDueUp()">
      <div>Due up:</div>
      <ng-container>
        <div *ngFor="let player of getDueUp()">
          {{utilService.getNumber(player, broadcast)}} {{ utilService.getName(player, broadcast).toUpperCase() }}
        </div>
      </ng-container>
    </div>
    <div class="logo" *ngIf="!isFinished()">
      <img [src]="broadcast?.config?.smallLogoUrl" alt="league-logo">
    </div>
  </div>
  <div class="status-msg" *ngIf="broadcast?.config?.statusMsg">
    {{ broadcast?.config?.statusMsg }}
  </div>
</div>
